<template>
  <div class="container">
    <div class="card o-hidden border-0 shadow-lg my-5">
      <div class="card-body p-0">
        <!-- Nested Row within Card Body -->
        <div class="row">
          <div class="col-lg-12">
            <div class="p-5">
              <div v-if="registration">
                <div class="text-center">
                  <h1 class="h4 text-gray-900 mb-4">
                    Create your Vendor Account
                  </h1>
                </div>
                <form class="user" v-on:submit.prevent="AddVendor">
                  <div class="form-group row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="text"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.shopDetails.name"
                        placeholder="Shop Name"
                      />
                    </div>
                    <div class="col-sm-6">
                      <input
                        type="email"
                        class="form-control form-control-user2"
                        v-model="newVendor.shopDetails.email"
                        required
                        placeholder="Shop Email"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="text"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.personalDetails.name"
                        placeholder="Vendor Name"
                      />
                    </div>
                    <div class="col-sm-6">
                      <input
                        type="number"
                        class="form-control form-control-user2"
                        v-model="newVendor.personalDetails.number"
                        required
                        placeholder="Vendor Number"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="emil"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.personalDetails.email"
                        placeholder="Vender Email"
                      />
                    </div>
                    <div class="col-sm-6">
                      <input
                        type="password"
                        class="form-control form-control-user2"
                        required
                        v-model="password"
                        placeholder="Password"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12 mb-3 mb-sm-0">
                      <b-form-select
                        v-model="newVendor.deliveryArea"
                        required
                        :options="deliveryArea"
                        class="form-control form-control-user2"
                      ></b-form-select>
                    </div>
                  </div>

                  <!-- Adress begins -->

                  <div class="form-group row">
                    <div class="col-sm-12 mb-3 mb-sm-0">
                      <input
                        v-model="search"
                        @change="callgenurl"
                        type="text"
                        class="form-control form-control-user2"
                        placeholder="Enter your Address Keywords and press Enter to show the list of Addresses matching your request"
                      />
                    </div>
                  </div>

                  <div class="form-group row" v-if="show">
                    <div class="col-sm-12 mb-3 mb-sm-0">
                      <b-form-select
                        v-model="selected"
                        required
                        :options="shownAddress"
                        :select-size="2"
                        @change="genlatlong"
                      ></b-form-select>
                    </div>
                  </div>
                  <div
                    class="form-group row"
                    style="color: red; text-align:center;"
                  >
                    <div class="col-sm-12 mb-3 mb-sm-0">
                      <p>
                        <b
                          >* The form below will be filled automatically with
                          the entry chosen, if you want any updates kindly edit
                          them *</b
                        >
                      </p>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12 mb-3 mb-sm-0">
                      <input
                        type="text"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.shopDetails.address.firstLine"
                        placeholder="Shop Address (Shop, Market, Street)"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 mb-3 mb-sm-0">
                      <input
                        type="text"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.shopDetails.address.state"
                        placeholder="State"
                      />
                    </div>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.shopDetails.address.city"
                        placeholder="City"
                      />
                    </div>
                    <div class="col-sm-4">
                      <input
                        type="number"
                        class="form-control form-control-user2"
                        required
                        v-model="newVendor.shopDetails.address.pincode"
                        placeholder="Pincode"
                      />
                    </div>
                  </div>
                  <!-- adress section ends -->

                  <button
                    type="submit"
                    class="btn btn-primary btn-user btn-block"
                  >
                    Register Account
                  </button>
                </form>
              </div>
              <div v-else style="height:500px;">
                <div class="text-center pt-5">
                  <sweetalert-icon icon="success" />
                  <h1>Registraion Successfull</h1>
                </div>
              </div>
              <div class="text-center pt-5">
                <router-link :to="'/vendor'">
                  Already have an account? Login!</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Auto complete google map
import axios from "axios";
import constants from "@/modules/constants";
import { vendorRegistration } from "@/modules/auth";
import router from "@/modules/router";
import SweetalertIcon from "vue-sweetalert-icons";
export default {
  //use as a component
  data() {
    return {
      selected: "",
      show: false,
      data: [],
      shownAddress: ["This might a few seconds to load please wait"],
      search: "",
      password: "",
      registration: true,
      newVendor: {
        deliveryArea: null,
        payment: {
          bankDetails: { ifsc: "", name: "", number: "" },
          history: {}
        },
        personalDetails: {
          email: "",
          name: "",
          number: ""
        },
        shopDetails: {
          address: {
            city: "",
            firstLine: "",
            latlong: { lat: "", long: "" },
            pincode: "",
            state: ""
          },
          name: "",
          email: ""
        },
        status: 0
      },
      deliveryArea: [
        {
          value: null,
          text: "Select Area for Delivery"
        },
        {
          value: 5,
          text: "5 KM"
        },
        {
          value: 10,
          text: "10 KM"
        },
        {
          value: 15,
          text: "15 KM"
        },
        {
          value: 20,
          text: "20 KM"
        }
      ]
    };
  },
  methods: {
    callgenurl() {
      this.show = false;
      this.shownAddress = ["This might take a few seconds to load please wait"];
      this.selected = "";
      var arr = [];
      if (this.search != "") {
        arr = this.search.split(" ");
        var final = "";
        for (var i = 0; i < arr.length; i++) {
          if (i == arr.length - 1) {
            final = final + arr[i];
          } else {
            final = final + arr[i] + "+";
          }
        }
        //console.log(final);
        var url =
          "https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/autocomplete/json?input=" +
          final +
          "&key=AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI";
        //console.log(url);
        axios(url, {
          method: "GET"
        }).then(response => {
          this.data = response.data;
          this.shownAddress = [];
          //console.log(this.data.predictions);
          for (var i = 0; i < this.data.predictions.length; i++) {
            //console.log("enter");
            //console.log(this.data.predictions[i].description);
            this.shownAddress.push(this.data.predictions[i].description);
          }
        });
        this.show = true;
      }
    },
    genlatlong() {
      //console.log("entry latlong");
      if (this.selected != "") {
        var entry = [];
        var arr = this.selected.split();
        var final = "";
        for (var i = 0; i < arr.length; i++) {
          if (i == arr.length - 1) {
            final = final + arr[i];
          } else {
            final = final + arr[i] + "+";
          }
        }
        //console.log(final);
        var url =
          "https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/geocode/json?address=" +
          final +
          "&key=AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI";
        //console.log(url);
        axios(url, {
          method: "GET"
        }).then(response => {
          entry = response.data;
          var components = entry.results[0].address_components;
          var len = components.length;
          //console.log(entry);
          this.newVendor.shopDetails.address.latlong.lat =
            entry.results[0].geometry.location.lat;

          this.newVendor.shopDetails.address.latlong.long =
            entry.results[0].geometry.location.lng;

          this.newVendor.shopDetails.address.pincode = parseInt(
            entry.results[0].address_components[len - 1].long_name,
            10
          );

          this.newVendor.shopDetails.address.state =
            entry.results[0].address_components[len - 3].long_name;
          this.newVendor.shopDetails.address.firstLine =
            entry.results[0].formatted_address;
          this.newVendor.shopDetails.address.city =
            entry.results[0].address_components[len - 5].long_name;

          //console.log(this.newVendor.shopDetails.address.latlong);
        });
      }
    },
    AddVendor() {
      let email = this.newVendor.personalDetails.email;
      let password = this.password;
      let name = this.newVendor.personalDetails.name;
      if (!(email && password && name)) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      if (
        email.trim().length === 0 ||
        password.trim().length === 0 ||
        name.trim().length === 0
      ) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
          email
        )
      ) {
        this.$root.toast(constants.errors.fill_fields["auth/invalid-email"]);
      }
      this.show = false;
      vendorRegistration(email, password, name, this.newVendor)
        .then(user => {
          this.$root.toast(
            "Welcome, " +
              (user.displayName.split(" ")[0] || user.displayName) +
              "!"
          );
          this.cleardataShow();
          this.$root.logout();
          this.redirect_vendor_login();
          //   });
        })
        .catch(() => {
          this.$root.toast(constants.errors.error);
        })
        .finally(() => {});
    },
    redirect_vendor_login() {
      router.push("/vendor");
    },
    cleardataShow() {
      this.newVendor = {
        deliveryArea: "",
        payment: {
          bankDetails: { ifsc: "", name: "", number: "" },
          history: {}
        },
        personalDetails: {
          email: "",
          name: "",
          number: ""
        },
        shopDetails: {
          address: {
            city: "",
            firstLine: "",
            latlong: { _lat: "", _long: "" },
            pincode: "",
            state: null
          },
          name: "",
          email: ""
        },
        status: 0
      };
      this.registration = false;
    }
  },
  components: {
    SweetalertIcon
  }
};
</script>

<style scoped>
.form-control-user2 {
  font-size: 1rem;
  border-radius: 10rem;
  height: 50px;
}
</style>
